import { Component, Inject, OnInit } from '@angular/core';
import { LoaderComponent } from '../../../shared/components/loader/loader.component';
import { LoaderService } from '../../../shared/services/loader.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from 'ddmo-storybook-lib';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgIf } from '@angular/common';
import { SharedService } from '../../../shared/services/shared.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-processing',
    imports: [LoaderComponent],
    templateUrl: './processing.component.html',
    styleUrl: './processing.component.scss'
})
export class ProcessingComponent {

  constructor(private loaderService : LoaderService){

  }
ngOnInit(){
  this.displayLoader()
}

displayLoader(){
  this.loaderService.show()
}
}


@Component({
    selector: 'app-delete-pretreatment-estimate-popup',
    imports: [ButtonComponent, MatIconModule, MatDialogModule, NgIf],
    template: `<div class="model__container">    
  <!-- <mat-dialog-actions class=" ">
      <button class="button-close" mat-icon-button (click)="onClose()" aria-label="close">
          <mat-icon aria-label="Close dialog">close</mat-icon>
      </button>
  </mat-dialog-actions> -->


<mat-dialog-content>


  <div *ngIf="!deleted" >
      <div class="model-popup-main-outr">
          <div class="delete-subimg-outer">
              <img src="assets/images/warning-sub-ico.svg" class="delete-subimg">
          </div>
          <div class="delete-subimg-outer-rght">
              <div class="popup-right-head ">{{headerMessage}}</div>
              <div class="popup-right-txt">{{message}}</div>
          </div>
      </div>  
      <div class=" ">
          <div class="buttons-fotr-new" *ngIf="!iserror">
              <app-button id="submitBtn"  (click)="deleteCredentialApplication()"  label="Yes" [isFilled]="true"></app-button>
              <app-button id="cancel"   (click)="onClose(false)"  label="No" ></app-button>
          </div>
           <div class="buttons-fotr-new-small" *ngIf="iserror"> 
              <app-button id="submitBtn"  (click)="onClose(true)"  label="Ok" [isFilled]="true"></app-button>
          </div>
      </div>   
          
  </div>


  <div *ngIf="deleted">
      <div class="model-popup-main-outr">
          <div class="delete-subimg-outer">          
              <img src="assets/images/save-sub-ico.svg" class="delete-subimg">
          </div>
          <div class="delete-subimg-outer-rght" *ngIf="deleted">
              <div class="popup-right-head ">Deleted</div>
              <div class="popup-right-txt">{{message}}</div>
          </div>
      </div>  
      <div class=" ">
          <div class="buttons-fotr-new-small"> 
              <app-button id="submitBtn"  (click)="onClose(true)"  label="Ok" [isFilled]="true"></app-button>
          </div>
      </div>   
  </div>
</mat-dialog-content>
</div>
                
                `,
    styleUrl: './processing.component.scss'
})
export class DeletePopupComponent {
  deleted: boolean = false;
  headerMessage: string ='';
  message: string ='';
  iserror = false

  constructor(private dialogRef: MatDialogRef<DeletePopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private loaderService:LoaderService,private sharedService: SharedService,private router: Router) { }

  ngOnInit(){
    this.message = this.data? this.data.message:"";
    this.headerMessage = "Alert";
  }
  onClose(flag:any) {
    this.dialogRef.close(flag);
  }
  deletePreTreatment() {
    this.loaderService.show()
    this.loaderService.hide()
    this.deleted=true;
    this.message = "Your application is deleted successfully"
  }
  deleteCredentialApplication() {
    this.loaderService.show();
    const payload = {
      credentialingEventId: localStorage.getItem("credentialingEventId"),
      userId: localStorage.getItem("loggedUserId")
    };
    this.sharedService.deleteCredentialApplication(payload).subscribe({
      next: (res: any) => {
        this.deleted = true;
        this.iserror = false;
        this.message = "Your application is deleted successfully";
        this.loaderService.hide();
      },
      error: (err) => {
        this.deleted = false;
        this.iserror = true;
        this.message = "Please try after some time. We are facing an issue while deleting the application.";
        this.loaderService.hide();
        this.sharedService.logError("APIFailed","FileDeletePopupComponent - deleteCredentialApplication, Method:deleteCredentialApplication", this.router.url.split('?')[0],err ).subscribe();
      }
    });
  }
}

@Component({
    selector: 'app-submit-credential-confirmation-popup',
    imports: [ButtonComponent, MatIconModule, MatDialogModule, NgIf],
    template: `<div class="model__container">    
  <!-- <mat-dialog-actions class=" ">
      <button class="button-close" mat-icon-button (click)="onClose()" aria-label="close">
          <mat-icon aria-label="Close dialog">close</mat-icon>
      </button>
  </mat-dialog-actions> -->


<mat-dialog-content>


  <div *ngIf="!hasError && !confirmed" >
      <div class="model-popup-main-outr">
          <div class="delete-subimg-outer">
              <img src="assets/images/warning-sub-ico.svg" class="delete-subimg">
          </div>
          <div class="delete-subimg-outer-rght">
              <div class="popup-right-head">{{headerMessage}}</div>
              <div class="popup-right-txt">{{message}}</div>
          </div>
      </div>  
      <div class=" ">
          <div class="buttons-fotr-new" *ngIf="!iserror">
              <app-button id="submitBtn"  (click)="submitCredentialing()"  label="Yes" [isFilled]="true"></app-button>
              <app-button id="cancel"   (click)="onClose(false)"  label="No" ></app-button>
          </div>
           <div class="buttons-fotr-new-small" *ngIf="iserror"> 
              <app-button id="submitBtn"  (click)="onClose(true)"  label="Ok" [isFilled]="true"></app-button>
          </div>
      </div>   
          
  </div>


  <div *ngIf="!hasError && confirmed">
      <div class="model-popup-main-outr">
          <div class="delete-subimg-outer">          
              <img src="assets/images/save-sub-ico.svg" class="delete-subimg">
          </div>
          <div class="delete-subimg-outer-rght" *ngIf="confirmed">
              <div class="popup-right-head">Submitted</div>
              <div class="popup-right-txt">{{message}}</div>
          </div>
      </div>  
      <div class=" ">
          <div class="buttons-fotr-new-small"> 
              <app-button id="submitBtn"  (click)="onClose(true)"  label="Ok" [isFilled]="true"></app-button>
          </div>
      </div>   
  </div>

 <div *ngIf="hasError">
      <div class="model-popup-main-outr">
          <div class="delete-subimg-outer">          
              <img src="assets/images/warning-sub-ico.svg" class="delete-subimg">
          </div>
          <div class="delete-subimg-outer-rght" *ngIf="hasError">
              <div class="popup-right-head">Alert</div>
              <div class="popup-right-txt">{{message}}</div>
          </div>
      </div>  
      <div class=" ">
          <div class="buttons-fotr-new-small"> 
              <app-button id="submitBtn"  (click)="onClose(true)"  label="Ok" [isFilled]="true"></app-button>
          </div>
      </div>   
  </div>
</mat-dialog-content>
</div>
                
                `,
    styleUrl: './processing.component.scss'
})
export class ConfirmationPopupComponent {
  confirmed: boolean = false;
  headerMessage: string ='';
  message: string ='';
  iserror = false
  hasError = false
  isWHDeletion: boolean = false;
  constructor(private dialogRef: MatDialogRef<ConfirmationPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private loaderService:LoaderService,private sharedService: SharedService,private router: Router,public dialog: MatDialog) { }

  ngOnInit(){
    this.message = this.data? this.data.message:"";
    this.hasError = this.data? this.data.hasError : this.hasError
    this.headerMessage = "Alert";
    this.isWHDeletion = this.data? this.data.isWHDeletion:false;
  }
  onClose(flag:any) {
    this.dialogRef.close(flag);
  }
  submitCredentialing(){
    if(!this.isWHDeletion){
    this.confirmed = true
    this.loaderService.show()
    this.onClose(false);
    this.openPreview()
    this.loaderService.hide()
  }
  else{
    this.onClose(true);
  }
}
openPreview() {
  this.dialog.open(PreviewModalComponent, {
    maxWidth: '95%',
    maxHeight: '90vh',
    panelClass: 'preview-dialog',
    data: {"isCallfrom" : "finish"}
  });
}
submitCredentialApplication() {
  const payload = {
      credentialingEventId: localStorage.getItem("credentialingEventId") ? localStorage.getItem("credentialingEventId") : 1
  };
  this.sharedService.submitCredentialApplication(payload).subscribe({
      next: (response) => {
          this.message = "Thank you for your application! You may receive an email from Overjet -1-617-812-4425 if additional information is required. You may log in and check you application status anytime."
          this.loaderService.hide()
      },
      error: (err) => {
          let errorMessage = 'An error had occurred, please try again. If it continues, please contact Provider Relations.';
          this.message = errorMessage
          this.loaderService.hide()
          this.sharedService.logError("APIFailed", "FileConfirmationPopupComponent - submitCredentialApplication, Method:submitCredentialApplication", this.router.url.split('?')[0], err).subscribe();
      }
  });
}
}

@Component({
  selector: 'app-user-Termed-popup',
  imports: [ButtonComponent, MatIconModule, MatDialogModule],
  template: `<div class="model__container">    
<!-- <mat-dialog-actions class=" ">
    <button class="button-close" mat-icon-button (click)="onClose()" aria-label="close">
        <mat-icon aria-label="Close dialog">close</mat-icon>
    </button>
</mat-dialog-actions> -->


<mat-dialog-content>


<div>
    <div class="model-popup-main-outr">
        <div class="delete-subimg-outer">          
            <img src="assets/images/warning-sub-ico.svg" class="delete-subimg">
        </div>
        <div class="delete-subimg-outer-rght">
            <div class="popup-right-head">Alert</div>
            <div class="popup-right-txt">Dentist’s account has been termed. Please reach out to Provider Relations at <u><b> {{email}}</b> </u> for assistance.</div>
        </div>
    </div>  
    <div class=" ">
        <div class="buttons-fotr-new-small"> 
            <app-button id="submitBtn"  (click)="onClose(true)"  label="Ok" [isFilled]="true"></app-button>
        </div>
    </div>   
</div>


</mat-dialog-content>
</div>
              
              `,
  styleUrl: './processing.component.scss'
})
export class UserTermedComponent {
  headerMessage: string ='';
  message: string ='';
  email="credentialing@deltadentalmo.com"

  constructor(private dialogRef: MatDialogRef<UserTermedComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(){
    this.message = this.data? this.data.message:"";
    this.headerMessage = "Alert";
  }
  onClose(flag:any) {
    this.dialogRef.close(flag);
  }
}


import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PreviewModalComponent } from '../../landing/pages/preview/preview-model.component';
 
@Component({

  selector: 'app-pdf-viewer-dialog',

  standalone: true,

  imports: [MatDialogModule,ButtonComponent,NgIf],

  template: `
 <div class="model__container">    
  <!-- <mat-dialog-actions class=" ">
      <button class="button-close" mat-icon-button (click)="onClose()" aria-label="close">
          <mat-icon aria-label="Close dialog">close</mat-icon>
      </button>
  </mat-dialog-actions> -->


<mat-dialog-content>

 <div >
      <div class="model-popup-main-outr">
    <div class="delete-subimg-outer" *ngIf="showmsg">          
            <img src="assets/images/warning-sub-ico.svg" class="delete-subimg" >
        </div>
          <div class="delete-subimg-outer-rght" >
          <div class="popup-right-head" *ngIf="showmsg">Alert</div>
              <div class="popup-right-txt"  *ngIf="showmsg">{{message}}</div>
          </div>
      </div>  
      <div class=" ">
          <div class="buttons-fotr-new-small"> 
              <app-button id="submitBtn"  (click)="onClose(true)"  label={{label}} [isFilled]="true"></app-button>
          </div>
      </div>   
  </div>
</mat-dialog-content>
</div>
  `,
 styleUrl: './processing.component.scss'
})

export class PdfViewerDialogComponent implements OnInit{
 
  message:string = ""
  showmsg = false
 label = "I agree"
 isError = false
 hasReadToBottom = false;
  constructor(private dialogRef: MatDialogRef<UserTermedComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private loaderService:LoaderService,private sharedService: SharedService,private router: Router

  ) {


  }
  ngOnInit(): void {
    if(this.data){
      this.message = this.data.message
      this.showmsg = this.data.showmsg
      this.label = this.data.label
      this.isError = this.data.isError
    }
    this.dialogRef.backdropClick().subscribe(() => {
      if (this.showmsg && !this.isError) {
      this.dialogRef.close();
      this.router.navigate(['/landing']);
      }
      this.dialogRef.close(); 
    });
  }
  onClose(flag:any) {
      this.dialogRef.close(flag);
      if(!this.isError){
        this.router.navigate(['/landing']);
      }
  }
  submitCredentialApplication() {
    const payload = {
        credentialingEventId: localStorage.getItem("credentialingEventId") ? localStorage.getItem("credentialingEventId") : 1
    };
    this.sharedService.submitCredentialApplication(payload).subscribe({
        next: (response) => {
            this.showmsg = true
            this.isError=  false
            this.label = "Ok"
            this.message = "Thank you for your application! You may receive an email from Overjet -1-617-812-4425 if additional information is required. You may log in and check you application status anytime."
            this.loaderService.hide()
        },
        error: (err) => {
            let errorMessage = 'An error had occurred, please try again. If it continues, please contact Provider Relations.';
            this.message = errorMessage
            this.showmsg = true
            this.label = "Ok"
            this.isError = true
            this.loaderService.hide()
            this.sharedService.logError("APIFailed", "FileConfirmationPopupComponent - submitCredentialApplication, Method:submitCredentialApplication", this.router.url.split('?')[0], err).subscribe();
        }
    });
  }
  onScroll(el: HTMLElement): void {
    // If the user has already scrolled to the bottom once, don't keep calculating
    if (this.hasReadToBottom) return;
 
    // Logic: Current Scroll + Visible Area >= Total Content Height
    const threshold = 5; // 5px buffer for better UX
    const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
 
    if (isAtBottom) {
      this.hasReadToBottom = true;
    }
  }
  attestUserAuditlog(){
    let auditLog:any={};
    auditLog["websiteCodeId"] = 50;
    auditLog["trailType"]='Trail';
    auditLog["trailWebSessionId"]=localStorage.getItem("trailWebSessionId")?.toUpperCase();
    auditLog["absolutePath"]=this.router.url;
    let userId = parseInt(localStorage.getItem("loggedUserId")!);
    auditLog["userId"] = userId ? userId : 0
    auditLog["impersonateId"]=0;
    auditLog["notes"]= "Attestation: Confirmed"
    this.sharedService.logWebTraillog(auditLog).subscribe(data=>{
    });
  }

}
 
@Component({
  selector: 'app-user-Termed-popup',
  imports: [ButtonComponent, MatIconModule, MatDialogModule, NgIf,CommonModule],
  template: `<div class="model__container">    
 <button class="button-close closebtn" mat-icon-button (click)="onClose(false)" aria-label="close">
        <mat-icon aria-label="Close dialog">close</mat-icon>
    </button>
<mat-dialog-content>


<div *ngIf="!deleted">
    <div class="model-popup-main-outr">
        <div class="delete-subimg-outer">          
            <img src="assets/images/warning-sub-ico.svg" class="delete-subimg">
        </div>
        <div class="delete-subimg-outer-rght">
            <div class="popup-right-head">Alert</div>
            <div class="popup-right-txt">{{message}}</div>
        </div>
    </div>  
    <div class=" ">
        <div class="buttons-fotr-new-small"
        [ngClass]="{'button-align': isPrimaryLocationAlert}">
            <app-button id="submitBtn"  (click)="onClose(true)"  label="{{label}}"[isFilled]="true"></app-button>
            <app-button id="submitBtn"  (click)="onClose(false)"  label="Cancel" [isFilled]="true"
            *ngIf="isPrimaryLocationAlert"></app-button>
        </div>
    </div>   
</div>
  <div *ngIf="deleted">
      <div class="model-popup-main-outr">
          <div class="delete-subimg-outer">          
              <img src="assets/images/save-sub-ico.svg" class="delete-subimg">
          </div>
          <div class="delete-subimg-outer-rght" *ngIf="deleted">
              <div class="popup-right-head ">Deleted</div>
              <div class="popup-right-txt">{{message}}</div>
          </div>
      </div>  
      <div class=" ">
          <div class="buttons-fotr-new-small"> 
              <app-button id="submitBtn"  (click)="onClose(true)"  label="Ok" [isFilled]="true"></app-button>
          </div>
      </div>   
  </div>

</mat-dialog-content>
</div>
              
              `,
  styleUrl: './processing.component.scss'
})
export class W9AlertComponent {
  headerMessage: string ='';
  message: string ='';
  deleted : any
  isPrimaryLocationAlert = false
  label = "Ok"

  constructor(private dialogRef: MatDialogRef<W9AlertComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(){
    this.message = this.data? this.data.message:"";
    this.isPrimaryLocationAlert = this.data? this.data.isPrimaryLocationAlert:false;
    if(this.isPrimaryLocationAlert){
      this.label = "Okay"
    }else{
      this.label = "Ok"
    }
    this.deleted = this.data? this.data.deleted:false;
    this.headerMessage = "Alert";
  }
  onClose(flag:any) {
    this.dialogRef.close(flag);
  }
}